import React from 'react';

import PropTypes from 'prop-types';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, Grid, Typography} from '@material-ui/core';

import {FieldShape} from 'commons/shapes';
import {InferPropTypes} from 'commons/types/Types';
import {EfeButtonPrimary, EfeErrorMsg, EfeFormSection, EfeSupportMessage} from 'components';
import {ConstitutiveActServiceRequest} from 'commons/models';
import EfeDragAndDrop from 'components/efe-drag-and-drop/EfeDragAndDrop';
import {FileWithPath} from 'react-dropzone';

InnerFormDocsAct.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

function InnerFormDocsAct(
    props: InferPropTypes<
        typeof InnerFormDocsAct.propTypes & FormikProps<ConstitutiveActServiceRequest>
    >
) {
    const {values, errors, fields, isSubmitting, setFieldValue} = props;
    const [uploadedFiles, setUploadedFiles] = React.useState<Array<FileWithPath>>([]);

    React.useEffect(() => {
        if (values && values.file) {
            try {
                const file = new File([values.file], 'acta_constitutiva');
                const filePath = {...file};
                filePath.size = file.size;
                filePath.name = file.name;
                setUploadedFiles([filePath]);
            } catch (error) {
                console.error(error);
            }
        }
    }, [values]);

    function setFile(file: string | ArrayBuffer) {
        setFieldValue('file', file);
    }

    function uploadFile(file: FileWithPath) {
        if (file) {
            setUploadedFiles([file]);
            const reader = new FileReader();
            reader.onload = () => {
                setFile(reader.result ? reader.result : '');
            };
            reader.readAsDataURL(file);
        }
    }

    function deleteFile(index: number) {
        if (uploadedFiles && uploadedFiles.length) {
            uploadedFiles.splice(index, 1);
            const aux = [...uploadedFiles];
            setUploadedFiles(aux);
            setFieldValue('file', '');
        }
    }

    /* eslint-disable react/jsx-handler-names */
    return (
        <Form noValidate>
            {fields && fields.length > 0 && (
                <Box m={2}>
                    <EfeSupportMessage />
                    <Box mt={4} mb={4}>
                        <Typography variant='body2' color='textPrimary'>
                            {
                                'Sube tu Acta Constitutiva, esta debe incluir Folio Mercantil o Boleta de Inscripci\u00F3n emitido ante el Registro P\u00FAblico de la Propiedad y del Comercio.'
                            }
                        </Typography>
                    </Box>
                    <EfeFormSection
                        fields={fields}
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                    />
                    <EfeDragAndDrop
                        maxSizeFile={25}
                        numFiles={1}
                        file={values.file}
                        fileList={uploadedFiles}
                        deleteFile={deleteFile}
                        loadFile={uploadFile}
                    />
                    {errors.file && (
                        <Box>
                            <EfeErrorMsg message={errors.file} />
                        </Box>
                    )}
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            )}
        </Form>
    );
}

export default InnerFormDocsAct;
